export const compare = (options = {}) => new Intl.Collator(void 0, options).compare;
export const defaultCompare = compare();
